import {DisplayPropertyType} from '../../content/displayproperties/DisplayProperties';
import TextCell from './TextCell';
import ImageCell from './ImageCell';
import MultiImageCell from './MultiImageCell';

export namespace CellFactory {
    export function GetCellTypeFromDisplayPropertyType(
        type: DisplayPropertyType
    ): any {
        switch (type) {
            case DisplayPropertyType.TEXT:
                return TextCell;
            case DisplayPropertyType.IMAGE:
                return ImageCell;
            case DisplayPropertyType.MULTI_IMAGE:
                return MultiImageCell;
        }
    }
}
